// employment status
export enum EMPLOYMENT_STATUS {
  FULLTIME = 'fullTime',
  PARTTIME = 'partTime',
  SELFEMPLOYED = 'selfEmployed',
  CASUAL = 'casual',
  CONTRACTOR = 'contractor',
  UNEMPLOYED = 'unemployed',
  PENSION = 'pension',
}
export const employmentStatusOptions = Object.values(EMPLOYMENT_STATUS)
export type EmploymentStatus = (typeof employmentStatusOptions)[number]
export const employmentStatusMap = {
  [EMPLOYMENT_STATUS.FULLTIME]: 'Full Time',
  [EMPLOYMENT_STATUS.PARTTIME]: 'Part Time',
  [EMPLOYMENT_STATUS.SELFEMPLOYED]: 'Self Employed',
  [EMPLOYMENT_STATUS.CASUAL]: 'Casual',
  [EMPLOYMENT_STATUS.CONTRACTOR]: 'Contractor',
  [EMPLOYMENT_STATUS.UNEMPLOYED]: 'Unemployed',
  [EMPLOYMENT_STATUS.PENSION]: 'Pension',
}

// Labels used to satisfy Motiv's UK submission contract for applicants who are
// unemployed or retired — Motiv still requires non-empty jobTitle / employer
// strings for those statuses. Temporary until Motiv makes those fields
// optional (DCX-422).
export const MOTIV_UK_UNEMPLOYMENT_LABELS: Partial<Record<EMPLOYMENT_STATUS, string>> = {
  [EMPLOYMENT_STATUS.PENSION]: 'Retired',
  [EMPLOYMENT_STATUS.UNEMPLOYED]: 'Benefits',
}

// refactored employment status
export enum REF_EMPLOYMENT_STATUS {
  FULLTIME = 1,
  PARTTIME = 2,
  SELFEMPLOYED = 3,
  CASUAL = 4,
  CONTRACTOR = 5,
  UNEMPLOYED = 6,
  PENSION = 7,
}
export const refEmploymentStatusOptions = Object.values(REF_EMPLOYMENT_STATUS)
export type RefEmploymentStatus = (typeof refEmploymentStatusOptions)[number]
export const refEmploymentStatusMap = {
  [REF_EMPLOYMENT_STATUS.FULLTIME]: 'Full Time',
  [REF_EMPLOYMENT_STATUS.PARTTIME]: 'Part Time',
  [REF_EMPLOYMENT_STATUS.SELFEMPLOYED]: 'Self Employed',
  [REF_EMPLOYMENT_STATUS.CASUAL]: 'Casual',
  [REF_EMPLOYMENT_STATUS.CONTRACTOR]: 'Contractor',
  [REF_EMPLOYMENT_STATUS.UNEMPLOYED]: 'Unemployed',
  [REF_EMPLOYMENT_STATUS.PENSION]: 'Pension',
}

// income frequency
export enum INCOME_FREQUENCY {
  YEARLY = 'yearly',
  MONTHLY = 'monthly',
  FORTNIGHTLY = 'fortnightly',
  WEEKLY = 'weekly',
}
export const incomeFrequencyOptions = Object.values(INCOME_FREQUENCY)
export type IncomeFrequency = (typeof incomeFrequencyOptions)[number]
export const incomeFrequencyMap = {
  [INCOME_FREQUENCY.YEARLY]: 'Yearly',
  [INCOME_FREQUENCY.MONTHLY]: 'Monthly',
  [INCOME_FREQUENCY.FORTNIGHTLY]: 'Fortnightly',
  [INCOME_FREQUENCY.WEEKLY]: 'Weekly',
}
